import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import AdminInformationSection from './createAdminForm/AdminInformationSection';
import { createAdministrator } from '../../api/Admin';
import { useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';

function AddAdminModal(props) {
  const {
    admins,
    setToastType,
    setToastTitle,
    setToastBody,
    setShowToast,
    ...rest
  } = props;
  const [updating, setUpdating] = useState(false);

  const administratorSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(/^[A-Öa-ö\-]*$/, 'Endast bokstäver tillåtet')
      .min(2, 'För kort förnamn')
      .max(20, 'För långt förnamn')
      .required('Du måste ange ett förnamn'),
    lastName: Yup.string()
      .matches(/^[A-Öa-ö\-]*$/, 'Endast bokstäver tillåtet')
      .min(2, 'För kort efternamn')
      .max(20, 'För långt efternamn')
      .required('Du måste ange ett efternamn'),
    email: Yup.string()
      .email('Fel format på angiven e-post')
      .test(
        'check-availability',
        'Angiven e-post är redan registrerad',
        function (value) {
          for (let i = 0; i < admins?.length; i++) {
            if (value === admins[i]?.email) {
              return false;
            }
          }
          return true;
        }
      )
      .required('Du måste ange en e-postadress'),
    password: Yup.string()
      .required('Du måste ange ett lösenord')
      .min(8, 'Lösenord måste innehålla minst 8 tecken')
      .matches(/[0-9]/, 'Lösenordet måste innehålla minst en siffra')
      .matches(/[a-z]/, 'Lösenordet måste innehålla minst en liten bokstav')
      .matches(/[A-Z]/, 'Lösenordet måste innehålla minst en stor bokstav')
      .matches(
        /[""!@$%^&*(){}\[\]:;<>,.?/+_=|'~\\-]/,
        'Lösenordet måste innehålla minst ett specialtecken'
      ),
  });

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ny administratör</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Skapa ett nytt administratörskonto</p>

        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            password: '',
          }}
          onSubmit={async (values) => {
            setUpdating(true);
            const result = await createAdministrator(values);
            if (result) {
              switch (result.statusCode) {
                case 200:
                  setToastType('success');
                  setToastTitle('Administratör skapad');
                  setToastBody('Administratören har blivit skapad');
                  break;
                default:
                  setToastType('danger');
                  setToastTitle('Administratör ej skapad');
                  setToastBody('Administratören kunde inte skapas');
                  break;
              }
              props.onHide();
              setShowToast(true);
              setUpdating(false);
            }
          }}
          validationSchema={administratorSchema}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <FormikForm
              id='form-add-administrator'
              noValidate
              onSubmit={handleSubmit}
            >
              <AdminInformationSection
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
              />
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='form-add-administrator'>
          {updating ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
              Skapa konto
            </>
          ) : (
            'Skapa konto'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddAdminModal;
